import { render } from "./IntegrationAdd.vue?vue&type=template&id=5d3bf3e6&ts=true"
import script from "./IntegrationAdd.vue?vue&type=script&lang=ts"
export * from "./IntegrationAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__